(function () {
    'use strict';

    /**
     * Country map section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_CountryMap.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "countryMapSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionCountryMap', sectionCountryMap);

    function sectionCountryMap() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionCountryMapCtrl,
            controllerAs: 'countryMapSection'
        };
    }

    SectionCountryMapCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionCountryMapCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        // null until loaded - the map is shown (ng-if) only once the data arrived
        vm.countries = null;

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the countries of the event participants
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetUsersCountries(eventId, lang).then(function (response) {
                vm.countries = response.data;
            });
        }
    }
})();
